export const SN_MYACCOUNT = 'myaccount'
export const MYACCOUNT_CHANGE_PERPAGE_PAGINATION = `${SN_MYACCOUNT}/MYACCOUNT_CHANGE_PERPAGE_PAGINATION`
export const MYACCOUNT_CHANGE_CURRENT_PAGINATION = `${SN_MYACCOUNT}/MYACCOUNT_CHANGE_CURRENT_PAGINATION`
export const MYACCOUNT_RESET_CURRENT_PAGINATION = `${SN_MYACCOUNT}/MYACCOUNT_RESET_CURRENT_PAGINATION`
